import {Directive, HostListener, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
	selector: '[libAutoResize]'
})
export class AutoresizeDirective implements OnInit {
	private readonly LINE_HEIGHT = 20;
	private readonly MAX_LINES = 15;

	@Input() maxHeight = 250;
	@Input() minHeight = 150;
	@Input() selector: string;

	constructor(private element: ElementRef<HTMLTextAreaElement>) {}

	@HostListener('input')
	onInput(): void {
		this.adjust();
	}

	ngOnInit(): void {
		this.adjust();
	}

	adjust(): void {
		const textarea = this.element.nativeElement;
		if (!textarea) return;

		textarea.style.height = 'auto';
		textarea.style.overflow = 'hidden';

		const estimatedLines = Math.ceil(textarea.scrollHeight / this.LINE_HEIGHT);
		const calculatedHeight = Math.min(
			estimatedLines * this.LINE_HEIGHT,
			this.MAX_LINES * this.LINE_HEIGHT,
			textarea.scrollHeight,
			this.maxHeight
		);

		const newHeight = Math.max(
			this.minHeight,
			Math.min(calculatedHeight, this.maxHeight)
		);


		if (textarea.value.length <= this.minHeight) {
			textarea.style.height = `${this.minHeight + (this.MAX_LINES * 2)}px`;
			return;
		}

		textarea.style.height = `${newHeight}px`;
		textarea.style.overflow = newHeight >= this.maxHeight ? 'auto' : 'hidden';
	}
}
